module.exports = __webpack_public_path__ + "static/icon3_how_it_works-c4f7352724f5697a9207e6a458e3e008.png";